var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedUnsuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 30C2 33.677 2.72424 37.318 4.13137 40.7151C5.5385 44.1123 7.60097 47.1989 10.201 49.799C12.8011 52.399 15.8877 54.4615 19.2849 55.8686C22.682 57.2758 26.323 58 30 58C33.677 58 37.318 57.2758 40.7151 55.8686C44.1123 54.4615 47.1989 52.399 49.799 49.799C52.399 47.1989 54.4615 44.1123 55.8686 40.7151C57.2758 37.318 58 33.677 58 30C58 26.323 57.2758 22.682 55.8686 19.2849C54.4615 15.8877 52.399 12.8011 49.799 10.201C47.1989 7.60097 44.1123 5.53851 40.7151 4.13137C37.318 2.72424 33.677 2 30 2C26.323 2 22.682 2.72424 19.2849 4.13137C15.8877 5.53851 12.8011 7.60097 10.201 10.201C7.60097 12.8011 5.5385 15.8877 4.13137 19.2849C2.72424 22.682 2 26.323 2 30Z",
    stroke: "#D42015",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19V35",
    stroke: "#D42015",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 40.4436V40.4669",
    stroke: "#D42015",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedUnsuccess);
export default __webpack_public_path__ + "static/media/redUnsuccess.482a772d3c691cb4b3a65a34a8708762.svg";
export { ForwardRef as ReactComponent };